import { render, staticRenderFns } from "./ResponsiveInfoMan.vue?vue&type=template&id=24d8d5e6&"
import script from "./ResponsiveInfoMan.vue?vue&type=script&lang=js&"
export * from "./ResponsiveInfoMan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports